import { Component } from '@angular/core';

import {ILoadingOverlayAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
  selector: 'dux-custom-overlay',
  templateUrl: './custom-overlay.component.html',
  styleUrls: ['./custom-overlay.component.scss']

})
export class CustomOverlayComponent implements ILoadingOverlayAngularComp {
    params: any;
    showSuccessOverlay: string;

    constructor() { }

    agInit(params: any): void {
        this.params = params;
        this.showSuccessOverlay = this.params.parentObject?.overlayType;
    }

    refreshData() {
        this.params.parentObject.applyFilter();
    }

    closeDialog() {
        this.params.parentObject.params.api.hideOverlay();
    }
}
